import {SODeleteHello} from '../../core/hello/so-delete-hello';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteHello extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteHello;
}